import { forwardRef } from 'react'

import type { Props as BasicSelectInputProps } from '../../Basic/SelectInput'
import type { ReactElement, ReactNode } from 'react'
import type { Props as SelectProps } from 'react-select'

import BasicSelectInput from '../../Basic/SelectInput'
import Wrapper from '../Wrapper'

interface Props extends BasicSelectInputProps {
  error?: ReactNode
}

const SelectInput = forwardRef(({ className, error, value = null, ...props }: Props & SelectProps): ReactElement => {
  return (
    <Wrapper className={className} error={error}>
      <BasicSelectInput {...props} value={value} />
    </Wrapper>
  )
})

SelectInput.displayName = 'SelectInput'

export default SelectInput
